import { render, staticRenderFns } from "./SchoolPicker.vue?vue&type=template&id=6ba6d0bd&"
import script from "./SchoolPicker.vue?vue&type=script&lang=js&"
export * from "./SchoolPicker.vue?vue&type=script&lang=js&"
import style0 from "./SchoolPicker.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports